module.exports = __webpack_public_path__ + "img/background-panel-hello.9de033a0.svg";